import React, { useState } from 'react';
import { Filter } from 'react-ionicons';
import { useQuery } from 'react-query';
import Skeleton from 'components/Skeleton/Skeleton';
import FilterDropdown from 'components/FilterDropdown';
import { getRecentUpdates } from 'api/orders/api';
import UpdatesList from './UpdatesList';
import { recentItemStatusOptions } from '../utils';

const RecentUpdates = () => {
  const [selected, setSelected] = useState<string[]>(
    recentItemStatusOptions().map((item) => item.value),
  );
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  const { data, isLoading, isFetching } = useQuery(
    ['order-tracking-recent-updates', selected],
    () => getRecentUpdates(selected),
    {
      staleTime: Infinity,
      onSuccess: () => {
        if (isFirstLoad) setIsFirstLoad(false);
      },
    },
  );

  const handleSelect = (item: { value: string }) => {
    setSelected((prev) => {
      if (prev.includes(item.value)) {
        return prev.filter((val) => val !== item.value);
      } else {
        return [...prev, item.value];
      }
    });
  };

  if (isLoading && isFirstLoad) {
    return <Skeleton className="h-full min-h-[338px] w-full !rounded" />;
  }

  return (
    <div className="flex h-full w-full flex-col gap-8 rounded bg-background-base-surface-2 p-6 shadow-elevation3">
      <div className="flex items-center justify-between text-content-base-default">
        <p className="text-xl font-bold">Recent updates</p>
        <FilterDropdown
          type="multi"
          label={<Filter color="currentColor" />}
          options={recentItemStatusOptions()}
          selected={selected}
          onSelect={handleSelect}
          showSelectAll={true}
        />
      </div>

      {isFetching ? (
        <div className="flex flex-col gap-4">
          {[...Array(2)].map((_, i) => (
            <Skeleton key={i} className="h-[100px] w-full rounded" />
          ))}
        </div>
      ) : (
        <UpdatesList data={(data || []).slice(0, 10)} selected={selected} />
      )}
    </div>
  );
};

export default RecentUpdates;
